// L'ESTAT DEL BOTÓ D'ENGEGAR DEL LLENÇ, i res més.
//
// Compte amb el nom: **això no té res a veure amb la pantalla «Simulacions» que es va treure el
// 27/08/2026**. Aquella era una llista d'execucions desades que no existien enlloc. Això d'aquí
// és si el llenç està corrent ara mateix, i ho llegeixen les dues barres d'eines per saber si
// han de dibuixar «engega» o «atura».
//
// No toca l'API: el motor viu al navegador, dins de `ModelCanvas` i `CausalLoopCanvas`. Els
// camps `simulations`, `currentSimulation` i `results` són de la plantilla i no els omple ningú.

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  simulations: [],
  currentSimulation: null,
  isRunning: false,
  results: [],
  loading: false,
  error: null,
};

const simulationSlice = createSlice({
  name: 'simulations',
  initialState,
  reducers: {
    startSimulation: (state) => {
      state.isRunning = true;
      state.error = null;
    },
    stopSimulation: (state) => {
      state.isRunning = false;
    },
    updateResults: (state, action) => {
      state.results = action.payload;
    },
    clearResults: (state) => {
      state.results = [];
    },
  },
});

export const { startSimulation, stopSimulation, updateResults, clearResults } = simulationSlice.actions;
export default simulationSlice.reducer;